import React, { useEffect, useMemo } from 'react';
import { UIGameVote } from './UIGameVote.tsx';
import { useGameStore } from '../../store/GameStoreContext.ts';
import { shouldRejectVoteOnClose } from './VoteCloseBehavior.ts';
import { VotePromptAutoHideTimer } from './VotePromptAutoHideTimer.ts';
import { getVoteViewState } from './VoteViewState.ts';
export const UIGameVoteContainer = ({ className, setLogVisible, setChatVisible })=>{
    const voteState = useGameStore((state)=>state.gameVote.voteState);
    const dismissVote = useGameStore((state)=>state.gameVote.dismissVote);
    const onVoteAccept = useGameStore((state)=>state.gameVote.onVoteAccept);
    const onVoteReject = useGameStore((state)=>state.gameVote.onVoteReject);
    const myColor = useGameStore((state)=>state.myColor);
    const votePromptAutoHideTimer = useMemo(()=>new VotePromptAutoHideTimer(), []);
    const hideVote = ()=>{
        if (!voteState) return;
        if (shouldRejectVoteOnClose(voteState, myColor)) onVoteReject(voteState.id);
        dismissVote(voteState.id);
    };
    useEffect(()=>{
        if (voteState == undefined) {
            votePromptAutoHideTimer.cancel();
            return;
        }
        const voteViewState = getVoteViewState(voteState, myColor);
        if (!VotePromptAutoHideTimer.shouldAutoHide(voteViewState)) {
            votePromptAutoHideTimer.cancel();
            return;
        }
        votePromptAutoHideTimer.schedule(voteState.id, dismissVote);
    }, [
        dismissVote,
        votePromptAutoHideTimer,
        myColor,
        voteState
    ]);
    useEffect(()=>{
        return ()=>votePromptAutoHideTimer.cancel();
    }, [
        votePromptAutoHideTimer
    ]);
    useEffect(()=>{
        if (voteState) {
            setLogVisible === null || setLogVisible === void 0 ? void 0 : setLogVisible(false);
        } else {
            setLogVisible === null || setLogVisible === void 0 ? void 0 : setLogVisible(true);
            setChatVisible === null || setChatVisible === void 0 ? void 0 : setChatVisible(true);
        }
    }, [
        voteState
    ]);
    if (!voteState) return null;
    return /*#__PURE__*/ React.createElement(UIGameVote, {
        onHideVote: hideVote,
        onVoteAccept: onVoteAccept,
        onVoteReject: onVoteReject,
        voteState: voteState,
        className: className
    });
};
